import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b117062"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "location-block" }
const _hoisted_2 = {
  key: 0,
  class: "title_green"
}
const _hoisted_3 = {
  key: 1,
  class: "title_green"
}
const _hoisted_4 = {
  key: 0,
  class: "location-block-wrapper"
}
const _hoisted_5 = { class: "location-block__element" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "location-block__title" }, " По метро ", -1 /* HOISTED */))
const _hoisted_7 = { class: "location-block__element" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "location-block__title" }, " Район ", -1 /* HOISTED */))

import { onMounted, ref, Ref } from 'vue';
import pSelect from '@/common/pSelect/pSelect.vue'
import { useSearchStore } from "@/searchSection/store/searchStore";
import api from "@/myProfileSection/api";
import MetroItemResponse from '@/myProfileSection/types/MetroItemResponse';
import DistrictItemResponse from '@/myProfileSection/types/DistrictItemResponse';
import ArrowIcon from '@/common/icons/ArrowIcon.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'LocationBlock',
  props: {
    visibleFiltersLocation: { type: Boolean }
  },
  emits: ['toggleFilter'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const searchStore = useSearchStore()

const metro: Ref<MetroItemResponse[]> = ref([]);
const districts: Ref<DistrictItemResponse[]> = ref([]);
onMounted(async () => {
  try {
    const [metroList, districtsList] = await Promise.all([api.getMetroList(), api.getDistrictList()])
    metro.value = metroList
    districts.value = districtsList
  } catch (e) {
    window.showNotification('Произошла ошибка!', 'error')
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "location-block__title title",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggleFilter')))
    }, [
      _createTextVNode(" Местоположение "),
      (_unref(searchStore).locationFilters)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Указаны " + _toDisplayString(_unref(searchStore).locationFilters) + " параметр ", 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, " Не указаны ")),
      _createVNode(ArrowIcon, {
        class: _normalizeClass(["title__arrow", { 'title__arrow_active': _ctx.visibleFiltersLocation }])
      }, null, 8 /* PROPS */, ["class"])
    ]),
    _createVNode(_Transition, { name: "fade-slide" }, {
      default: _withCtx(() => [
        (_ctx.visibleFiltersLocation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(pSelect, {
                  modelValue: _unref(searchStore).searchOptions.metroList,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchStore).searchOptions.metroList) = $event)),
                  selectionItems: metro.value,
                  multiple: "",
                  placeholder: "Выберите метро"
                }, null, 8 /* PROPS */, ["modelValue", "selectionItems"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(pSelect, {
                  modelValue: _unref(searchStore).searchOptions.districtList,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchStore).searchOptions.districtList) = $event)),
                  placeholder: "Выберите район или поиск будет по всем районам",
                  selectionItems: districts.value,
                  multiple: ""
                }, null, 8 /* PROPS */, ["modelValue", "selectionItems"])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})